import { TRPCClientError } from '@trpc/client';
// Turns a thrown tRPC / Zod error into a single human-readable line for a toast, instead of dumping
// the raw Zod issues array (which is what `error.message` is for a server-side Zod failure). Prefers
// the server's flattened `schemaErrors` (the same shape the legacy modals read), then a parsed
// Zod-issue message, then the plain message, then the fallback.
export const getReadableError = (error, fallback) => {
    var _a, _b, _c, _d;
    if (error instanceof TRPCClientError) {
        const schemaErrors = (_a = error.data) === null || _a === void 0 ? void 0 : _a.schemaErrors;
        const messages = [
            ...((_b = schemaErrors === null || schemaErrors === void 0 ? void 0 : schemaErrors.formErrors) !== null && _b !== void 0 ? _b : []),
            ...Object.values((_c = schemaErrors === null || schemaErrors === void 0 ? void 0 : schemaErrors.fieldErrors) !== null && _c !== void 0 ? _c : {}).flat(),
        ].filter(Boolean);
        const [first] = messages;
        if (first) {
            return first;
        }
    }
    if (error instanceof Error && error.message) {
        const message = error.message.trim();
        if (message.startsWith('[') || message.startsWith('{')) {
            try {
                const parsed = JSON.parse(message);
                const issues = (Array.isArray(parsed) ? parsed : [parsed]);
                return (_d = issues.map(issue => issue === null || issue === void 0 ? void 0 : issue.message).find(Boolean)) !== null && _d !== void 0 ? _d : fallback;
            }
            catch (_e) {
                return fallback;
            }
        }
        return message;
    }
    return fallback;
};
